import React from "react";
import { Link } from "react-router-dom";
import { Dots } from "react-dot-patterns";
import heroSectionImage from "../../../assets/machine-vision.jpg";

const HeroSection = () => {
  return (
    <div className="mvs-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Overview</h1>
            <p>
              Soori Corporation’s machine vision solutions use AI-powered image
              processing technology to automate visual inspections, ensuring
              precision and quality in manufacturing and production lines. This
              technology helps industries maintain high standards, reduce waste,
              and improve overall operational efficiency.
            </p>
            <Link to="/industry">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
